// DGTG brand constants
export const DGTG_BRAND = '#773DFF';
export const DGTG_BRAND_DARK = '#5B2ACC';
export const DGTG_BRAND_LIGHT = '#F3EEFF';

// Founded 2015 (owner confirmed 2026-09-27). Shown on the site and as foundingDate.
export const DGTG_FOUNDED = 2015;

// Official profiles. Also used as `sameAs` in the Organization structured data.
export const DGTG_SOCIALS = [
  { name: 'Instagram', icon: 'instagram', url: 'https://www.instagram.com/dgtg_live/' },
  { name: 'LinkedIn', icon: 'linkedin', url: 'https://www.linkedin.com/company/dgtglive/' },
];

export const DGTG_SERVICES = [
  {
    slug: 'lead-generation',
    title: 'Buy Leads',
    tagline: 'High-intent leads at scale, pay per qualified lead.',
    short: 'Generate high-intent leads through landing pages, API integrations, and multi-channel outreach.',
    icon: 'Target',
    inventory: ['Email', 'SMS', 'DSP', 'Landing Pages', 'API Integration'],
    stats: [
      { label: 'Leads', brand: 'Mahindra', value: '70,000+' },
      { label: 'Leads', brand: 'Volkswagen', value: '40,000+' },
      { label: 'Enquiry Ratio', value: '25-30%' },
      { label: 'Leads', brand: 'TATA AIG', value: '15,000+' },
    ],
    caseStudies: [
      { client: 'Mahindra & Mahindra', type: 'CPL', geo: 'PAN India', result: '70,000+ leads with 30% enquiry ratio (exceeded 25% KPI)', models: 'Scorpio, XUV700, Thar, Bolero, XUV500, XUV300', industry: 'automotive' },
      { client: 'Volkswagen', type: 'CPL', geo: 'PAN India', result: '40,000+ leads, Taigun (20K), Virtus (10K), Tiguan (10K)', models: 'Taigun, Virtus, Tiguan', industry: 'automotive' },
      { client: 'TATA AIG', type: 'CPL Insurance', geo: 'PAN India', result: '15,000+ leads with 0.75% sales conversion', models: '', industry: 'bfsi' },
      { client: 'CIBIL TransUnion', type: 'CPL', geo: 'PAN India', result: '200K+ visits with 0.75% conversion', models: '', industry: 'bfsi' },
    ],
    desc: 'We deliver high-intent leads through client-provided landing pages or direct API integration. Multi-channel, Email, SMS, DSP, with quality benchmarks like enquiry-to-lead ratios above 25%.',
    industries: ['automotive', 'bfsi', 'infrastructure', 'agro-based'],
  },
  {
    slug: 'traffic-campaigns',
    title: 'Buy Traffic',
    tagline: 'High-quality traffic at scale, pay per visit with KPI guarantees.',
    short: 'Drive targeted traffic to landing pages, videos, and web properties with measurable KPIs.',
    icon: 'BarChart3',
    inventory: ['Email', 'SMS', 'WhatsApp', 'DSPs', 'Display', 'Native'],
    stats: [
      { label: 'Visits', brand: 'Mahindra', value: '2M+' },
      { label: 'Visits', brand: 'Realme', value: '5M+' },
      { label: 'Prime Video views', brand: 'Amazon', value: '20M' },
      { label: 'Clicks', brand: 'PhonePe', value: '2M' },
    ],
    caseStudies: [
      { client: 'Mahindra', type: 'CPV', geo: 'PAN India', result: '2M+ visits with 60 sec+ avg session time', models: 'Scorpio, XUV700, Thar', industry: 'automotive' },
      { client: 'Realme', type: 'Cost Per Unique Visit', geo: 'PAN India', result: '5M+ total visits with 70% unique visitor rate', models: 'Narzo 60 Pro, C53, 11X 5G', industry: 'it-electronics' },
      { client: 'Amazon Prime Video (Farzi)', type: 'CPV', geo: 'PAN India', result: '20M video views with high engagement', models: '', industry: 'ecommerce' },
      { client: 'PhonePe', type: 'CPC', geo: 'PAN India', result: '2M clicks for Covid Insurance product', models: '', industry: 'bfsi' },
    ],
    desc: 'We deliver online traffic to landing pages, videos, and other web properties. Client KPIs like bounce rate, average session time, and unique visitor percentage are maintained throughout the campaign.',
    industries: ['automotive', 'it-electronics', 'ecommerce', 'bfsi', 'retail'],
  },
  {
    slug: 'sale-campaigns',
    title: 'Get Sales',
    tagline: 'Performance-based sales, pay only when we deliver revenue.',
    short: 'Commission-based sales campaigns across cashback, coupons, email, SMS, and programmatic.',
    icon: 'ShoppingBag',
    inventory: ['Cashback Websites', 'Coupon Websites', 'Email', 'SMS', 'Display', 'SEM', 'SMM', 'Programmatic'],
    stats: [
      { label: 'Sales', brand: 'Buywow', value: '5,704' },
      { label: 'GMV', brand: 'Pilgrim', value: '76L+' },
      { label: 'Sales', brand: 'Samsung', value: '2,819' },
      { label: 'Avg Approval Rate', value: '89%' },
    ],
    caseStudies: [
      { client: 'Buywow', type: 'CPS E-Commerce', geo: 'India', result: '5,704 sales with 92% approval rate, 29.5L GMV', models: '', industry: 'ecommerce' },
      { client: 'Pilgrim Personal Care', type: 'CPS', geo: 'India', result: '3,457 sales with 92% approval, 76L GMV', models: '', industry: 'ecommerce' },
      { client: 'Samsung', type: 'CPS Electronics', geo: 'India', result: '2,819 sales with 87% approval, 11L GMV', models: '', industry: 'it-electronics' },
      { client: 'Adidas', type: 'CPS Sportswear', geo: 'India', result: '2,133 sales with 86% approval, 31L GMV', models: '', industry: 'retail' },
    ],
    desc: 'We run cost-per-sale campaigns where you pay commission only on successful sales. Inventory spans cashback websites, coupon platforms, email, SMS, display, SEM, SMM, and programmatic channels.',
    industries: ['ecommerce', 'it-electronics', 'retail'],
  },
  {
    slug: 'app-install',
    title: 'Get App Installs',
    tagline: 'From install to activation, real users, real engagement, real growth.',
    short: 'Acquire quality mobile app users across Education, Fintech, Shopping, Gaming, and more.',
    icon: 'Smartphone',
    inventory: ['In-App', 'Direct', 'DSP', 'SDK', 'Premium Sources'],
    stats: [
      { label: 'Installs', brand: 'Adda247', value: '4.3M+' },
      { label: 'Purchases', brand: 'Zivame', value: '16,089' },
      { label: 'Registrations', brand: 'Sweet TV', value: '36,000+' },
      { label: 'Installs', brand: 'Rage Effect', value: '100K' },
    ],
    caseStudies: [
      { client: 'Adda 247', type: 'CPI', geo: 'India', result: '4.3M+ installs with >80% registration and <30% uninstall rate', models: '', industry: 'education' },
      { client: 'Zivame', type: 'CPA Purchase', geo: 'India', result: '16,089 purchases, high volume quality acquisitions', models: '', industry: 'ecommerce' },
      { client: 'Sweet TV', type: 'CPR', geo: 'India', result: '36,000+ registrations with >25% success rate', models: '', industry: 'mobile-apps' },
      { client: 'Jeeny', type: 'CPA First Ride', geo: 'Saudi Arabia & Jordan', result: '612 first-ride events in 1 month', models: '', industry: 'mobile-apps' },
    ],
    desc: 'We target mobile users to download and register applications across Education, Fintech, Shopping, Streaming, Gaming, Entertainment, and Utility verticals. Anti-fraud measures maintain quality with <5% fraud rate.',
    industries: ['education', 'mobile-apps', 'ecommerce', 'bfsi', 'igaming-esports'],
  },
  {
    slug: 'social-media',
    title: 'Get Content, Likes, Shares & Comments',
    tagline: 'Social-first growth, content production, engagement, and community at scale.',
    short: 'Influencer-driven content production with managed engagement, likes, shares, comments, and follower growth across Instagram, YouTube, X, LinkedIn, and TikTok.',
    icon: 'MessageCircleHeart',
    inventory: ['Instagram', 'YouTube', 'X (Twitter)', 'LinkedIn', 'TikTok', 'Influencer Network', 'UGC Creators'],
    stats: [
      { label: 'Creators Onboarded', value: '5,000+' },
      { label: 'Reels/Posts per Month', value: '10,000+' },
      { label: 'Avg Engagement Lift', value: '4.2x' },
      { label: 'Communities Managed', value: '120+' },
    ],
    caseStudies: [
      { client: 'D2C Beauty Brand', type: 'Social Engagement', geo: 'India', result: '2.5M organic reach in 90 days via micro-influencer reels', models: '', industry: 'ecommerce' },
      { client: 'Fintech App Launch', type: 'Creator + UGC', geo: 'India', result: '180K branded mentions across IG + X driving 12K signups', models: '', industry: 'bfsi' },
      { client: 'Auto OEM Reveal', type: 'Concurrency + Social', geo: 'YouTube + IG Live', result: '128K concurrent live viewers + 4M post-launch impressions', models: 'MG COMET', industry: 'automotive' },
      { client: 'Gaming Studio', type: 'Community Build', geo: 'Discord + IG + X', result: '50K Discord community, 6M monthly reach from creators', models: '', industry: 'gaming-esports' },
    ],
    desc: 'We produce social-first content (Reels, Shorts, UGC, influencer collabs) and drive measurable engagement, likes, shares, comments, saves, follows. Our 5,000+ creator network covers every category from D2C beauty to fintech, gaming, and B2B SaaS. Built on the foundation of our market-leading concurrency campaigns (MG COMET 128K, Vivo V29 106K live viewers), now expanded to always-on social growth.',
    industries: ['ecommerce', 'it-electronics', 'bfsi', 'gaming-esports', 'retail', 'mobile-apps'],
  },
  {
    slug: 'influencer-marketing',
    title: 'Influencer Marketing',
    tagline: 'Creator campaigns planned against a number you can measure, not just reach.',
    short: 'Influencer and creator campaigns on Instagram, YouTube, X, LinkedIn and live streams, paid against installs, leads, sales or views where they can be tracked.',
    icon: 'MessageCircleHeart',
    inventory: ['Instagram Reels', 'YouTube videos and Shorts', 'YouTube and Instagram Live', 'X (Twitter)', 'LinkedIn creators', 'Gaming streamers', 'UGC creators', 'Regional-language creators'],
    stats: [
      { label: 'Creators in our network', value: '5,000+' },
      { label: 'Concurrent live viewers, COMET launch', brand: 'MG Motor', value: '128K' },
      { label: 'Concurrent live viewers, V29 launch', brand: 'Vivo', value: '106K' },
    ],
    caseStudies: [
      { client: 'MG Motor', type: 'Live launch', geo: 'YouTube + Instagram Live', result: '128K concurrent live viewers for the MG COMET launch', models: 'MG COMET', industry: 'automotive' },
      { client: 'Vivo', type: 'Live launch', geo: 'YouTube + Instagram Live', result: '106K concurrent live viewers for the Vivo V29 launch', models: 'Vivo V29', industry: 'it-electronics' },
    ],
    desc: 'DGTG is an influencer marketing agency in Bengaluru working with creators across India, the Middle East and Southeast Asia. We plan influencer campaigns the way we plan paid media: start from the outcome the brand needs, pick the creators whose audience can deliver it, agree the price per deliverable or per result, and report on what the campaign actually moved.',
    sections: [
      { h: 'How an influencer campaign runs with us', p: 'You tell us the goal, the audience and the budget. We shortlist creators with the audience data behind each name, agree deliverables and rates, brief them, and approve every script or edit before it goes live. Each creator gets their own tracking link or promo code, so installs, sign-ups and sales can be traced back to the post that drove them. You get a report per creator, not one blended number.' },
      { h: 'Paid on results where results can be tracked', p: 'Influencer marketing does not have to be a fixed fee for a post and a hope. For app installs, leads and ecommerce sales we can run creator campaigns on a cost per install, cost per lead or cost per sale basis, the same models we use for our performance campaigns. Where the goal is awareness or a launch, we price per deliverable and report views, watch time and live concurrency instead.' },
      { h: 'Micro, mid-tier and top creators', p: 'A few large creators buy reach and attention on day one. Many micro-influencers with 10,000 to 100,000 followers usually buy trust and conversions in a specific niche for less. Most of our campaigns mix the two: a small number of recognisable faces for the launch moment, and a wider layer of niche creators and UGC for the weeks after.' },
      { h: 'Categories we know well', p: 'Gaming and esports creators and streamers, personal finance and fintech creators, auto reviewers, tech and gadget channels, D2C beauty and fashion, and education. Each category has its own formats: a live stream for a phone launch, a long review for a car, a tutorial for a trading app.' },
      { h: 'Markets and languages', p: 'India, including Hindi and regional-language creators, the UAE and Saudi Arabia, and Southeast Asia. Regional-language creators often reach audiences that English-language campaigns miss entirely.' },
      { h: 'Disclosure and brand safety', p: 'Paid posts are disclosed. In India that follows the ASCI guidelines for influencer advertising, and we apply the equivalent rules in other markets. Before a creator is shortlisted we check follower quality and engagement for signs of bought audiences, and we review past content for anything that would embarrass the brand.' },
    ],
    faqs: [
      { q: 'How much does influencer marketing cost?', a: 'It depends on the creator tier, the platform and what they make: a Reel, a YouTube integration and a live stream are priced very differently. We quote per campaign after seeing the brief. The DGTG cost calculator gives a starting range for the channel mix you have in mind.' },
      { q: 'Can influencer campaigns be performance-based?', a: 'Yes, when the result can be tracked. Installs, leads and sales can be paid per result through each creator\'s tracking link or promo code. Awareness and launch campaigns are priced per deliverable.' },
      { q: 'Do you work with micro-influencers?', a: 'Yes. Most campaigns combine a few larger creators with a wider set of micro-influencers, because niche audiences tend to convert better per rupee.' },
      { q: 'Which platforms do you run influencer campaigns on?', a: 'Instagram, YouTube (videos, Shorts and live), X, LinkedIn and gaming streaming platforms, plus UGC creators who make content for your own ads.' },
      { q: 'Do creators disclose that a post is paid?', a: 'Yes. Paid posts carry a clear disclosure, following the ASCI influencer advertising guidelines in India and the equivalent rules elsewhere.' },
    ],
    industries: ['automotive', 'it-electronics', 'gaming-esports', 'bfsi', 'ecommerce', 'education'],
  },
];

// Logos are served from /public/brands. The old logo.clearbit.com URLs died when Clearbit shut its free logo
// API, and every card fell back to a letter in a box. Sources: Simple Icons (CC0) for most, Wikimedia Commons
// (public domain) for Realme and TATA AIG. `logo: null` = no free official file yet; the name is set in type.
export const DGTG_BRANDS = [
  { name: 'Mahindra', logo: '/brands/mahindra.svg' },
  { name: 'Volkswagen', logo: '/brands/volkswagen.svg' },
  { name: 'TATA Motors', logo: '/brands/tata.svg' },
  { name: 'TATA AIG', logo: '/brands/tata-aig.png' },
  { name: 'MG Motor', logo: '/brands/mg.svg' },
  { name: 'Vivo', logo: '/brands/vivo.svg' },
  { name: 'Realme', logo: '/brands/realme.svg' },
  { name: 'Samsung', logo: '/brands/samsung.svg' },
  { name: 'Adidas', logo: '/brands/adidas.svg' },
  { name: 'PhonePe', logo: '/brands/phonepe.svg' },
  { name: 'Amazon', logo: '/brands/amazon.svg' },
  { name: 'Adda247', logo: null },
  { name: 'Zivame', logo: null },
  { name: 'Buywow', logo: null },
  { name: 'Pilgrim', logo: null },
];

export const DGTG_INDUSTRY_PAGES = [
  {
    slug: 'automotive',
    title: 'Automotive',
    headline: 'Drive automotive growth with performance marketing',
    desc: 'From lead generation to live product launches, DGTG helps automotive brands like Mahindra, Volkswagen, TATA Motors, and MG Motor reach high-intent buyers across India. We deliver qualified leads, drive test-drive bookings, and fill live launch events with real viewers.',
    icon: 'Car',
    keywords: 'automotive marketing, car lead generation, vehicle launch marketing, auto digital marketing India',
    stats: [
      { value: '70,000+', label: 'Leads for Mahindra' },
      { value: '40,000+', label: 'Leads for Volkswagen' },
      { value: '128K', label: 'Concurrent viewers for MG COMET launch' },
      { value: '2M+', label: 'Website visits for Mahindra models' },
    ],
  },
  {
    slug: 'gaming-esports',
    title: 'Gaming & Esports',
    headline: 'Acquire and activate players at scale',
    desc: 'DGTG powers user acquisition for gaming and esports platforms with app install campaigns, community engagement, and influencer partnerships. We deliver real players with high retention and low fraud rates.',
    icon: 'Gamepad2',
    keywords: 'gaming marketing, esports user acquisition, gaming app installs, mobile gaming marketing India',
    stats: [
      { value: '100K+', label: 'Gaming app installs' },
      { value: '<5%', label: 'Fraud rate maintained' },
      { value: '80%+', label: 'Registration rate' },
      { value: '50M+', label: 'Daily reach across channels' },
    ],
  },
  {
    slug: 'ecommerce',
    title: 'E-Commerce',
    headline: 'Turn clicks into customers with CPS campaigns',
    desc: 'DGTG drives measurable sales for e-commerce brands through cost-per-sale campaigns, cashback partnerships, coupon distribution, and programmatic advertising. Brands like Buywow, Pilgrim, and Samsung trust us to deliver high-approval-rate transactions.',
    icon: 'ShoppingCart',
    keywords: 'ecommerce marketing India, CPS campaigns, online sales marketing, performance marketing ecommerce',
    stats: [
      { value: '5,704', label: 'Sales for Buywow' },
      { value: '76L+', label: 'GMV for Pilgrim' },
      { value: '89%', label: 'Average approval rate' },
      { value: '20M', label: 'Video views for Amazon Prime' },
    ],
  },
  {
    slug: 'bfsi',
    title: 'BFSI',
    headline: 'Quality leads for banking, financial services & insurance',
    desc: 'DGTG delivers high-intent leads for BFSI brands through targeted campaigns. From TATA AIG insurance leads to CIBIL credit score signups and PhonePe product promotions, we maintain strict quality benchmarks and sales conversion KPIs.',
    icon: 'Landmark',
    keywords: 'BFSI marketing India, insurance lead generation, fintech marketing, banking digital marketing',
    stats: [
      { value: '15,000+', label: 'Leads for TATA AIG' },
      { value: '200K+', label: 'Visits for CIBIL' },
      { value: '2M', label: 'Clicks for PhonePe' },
      { value: '0.75%', label: 'Sales conversion rate' },
    ],
  },
  {
    slug: 'education',
    title: 'Education',
    headline: 'Acquire learners and drive registrations at scale',
    desc: 'DGTG helps education platforms like Adda247 acquire millions of app users with high registration rates and low uninstall rates. Our multi-channel approach ensures quality user acquisition across India.',
    icon: 'GraduationCap',
    keywords: 'education marketing India, edtech user acquisition, education app installs, student lead generation',
    stats: [
      { value: '4.3M+', label: 'Installs for Adda247' },
      { value: '80%+', label: 'Registration rate' },
      { value: '<30%', label: 'Uninstall rate' },
      { value: '50M+', label: 'Email database reach' },
    ],
  },
  {
    slug: 'it-electronics',
    title: 'IT & Electronics',
    headline: 'Launch products with massive reach and engagement',
    desc: 'DGTG powers product launches and sales campaigns for IT and electronics brands like Samsung, Vivo, and RealMe. From live launch events with 100K+ concurrent viewers to CPS campaigns with 87%+ approval rates.',
    icon: 'Cpu',
    keywords: 'electronics marketing India, tech product launch, Samsung marketing, smartphone launch campaigns',
    stats: [
      { value: '5M+', label: 'Visits for RealMe' },
      { value: '106K', label: 'Concurrent viewers for Vivo V29' },
      { value: '2,819', label: 'Sales for Samsung' },
      { value: '87.5K', label: 'Viewers for RealMe 11 Pro launch' },
    ],
  },
  {
    slug: 'retail',
    title: 'Retail',
    headline: 'Drive footfall and online sales for retail brands',
    desc: 'DGTG helps retail and sportswear brands like Adidas achieve measurable sales through CPS campaigns, programmatic advertising, and multi-channel distribution. Our cashback and coupon network drives high-quality transactions.',
    icon: 'Store',
    keywords: 'retail marketing India, fashion marketing, sportswear digital marketing, retail sales campaigns',
    stats: [
      { value: '2,133', label: 'Sales for Adidas' },
      { value: '31L+', label: 'GMV for Adidas' },
      { value: '86%', label: 'Approval rate' },
      { value: '100M+', label: 'SMS database reach' },
    ],
  },
  {
    slug: 'mobile-apps',
    title: 'Mobile Apps',
    headline: 'From install to first action, quality mobile acquisition',
    desc: 'DGTG specializes in mobile app user acquisition across streaming, ride-hailing, shopping, and utility verticals. We deliver real users who complete first actions, registrations, purchases, and first rides, across India, MENA, and beyond.',
    icon: 'Smartphone',
    keywords: 'mobile app marketing, app install campaigns India, CPI campaigns, mobile user acquisition',
    stats: [
      { value: '16,089', label: 'Purchases for Zivame' },
      { value: '36,000+', label: 'Registrations for Sweet TV' },
      { value: '612', label: 'First rides for Jeeny' },
      { value: '<5%', label: 'Fraud rate maintained' },
    ],
  },
  {
    slug: 'infrastructure',
    title: 'Infrastructure',
    headline: 'Generate qualified leads for infrastructure projects',
    desc: 'DGTG helps infrastructure and real estate companies generate qualified leads through targeted email, SMS, and DSP campaigns. Our PAN India database of 50M+ email contacts and 100M+ SMS contacts ensures wide reach.',
    icon: 'Building2',
    keywords: 'infrastructure marketing India, real estate lead generation, construction digital marketing',
    stats: [
      { value: '50M+', label: 'Email database' },
      { value: '100M+', label: 'SMS database' },
      { value: '25-30%', label: 'Enquiry ratio benchmark' },
      { value: 'PAN India', label: 'Coverage' },
    ],
  },
  {
    slug: 'agro-based',
    title: 'Agro-Based',
    headline: 'Reach farming communities with targeted campaigns',
    desc: 'DGTG reaches agricultural and agro-based business audiences through SMS, email, and regional language campaigns. Our wide-reaching database covers rural and semi-urban India for maximum penetration.',
    icon: 'Wheat',
    keywords: 'agricultural marketing India, agro business digital marketing, farming lead generation, rural marketing',
    stats: [
      { value: '100M+', label: 'SMS reach across India' },
      { value: '50M+', label: 'Daily user visits' },
      { value: 'PAN India', label: 'Regional coverage' },
      { value: 'Multi-language', label: 'Campaign support' },
    ],
  },
];

export const DGTG_INDUSTRIES = DGTG_INDUSTRY_PAGES.map(i => i.title);

export const DGTG_CLIENTS = [
  'Mahindra', 'Volkswagen', 'TATA Motors', 'TATA AIG', 'MG Motor',
  'Vivo', 'RealMe', 'Samsung', 'Adidas', 'PhonePe',
  'Amazon Prime', 'Adda247', 'Zivame', 'Buywow', 'Pilgrim',
];

export const DGTG_INVENTORY = {
  email: { label: 'Email Database', value: '50M+', desc: 'Verified email contacts across PAN India' },
  sms: { label: 'SMS Database', value: '100M+', desc: 'Mobile numbers for wide-reaching SMS campaigns' },
  reach: { label: 'Daily User Visits', value: '50M+', desc: 'Across web and app properties' },
};

// /partners: supply-side onboarding. Influencers, publishers, list owners, coupon and cashback sites and other
// media sign up here; sign-ups arrive as leads with source_id "dgtg-partner".
export const DGTG_PARTNERS = {
  title: 'Become a DGTG publisher or creator partner',
  description: 'Influencers, website publishers, email and SMS list owners, coupon and cashback sites, app developers and community owners: join the DGTG network and get paid campaigns from brands in India, the Middle East and Southeast Asia.',
  intro: 'DGTG runs lead generation, app install, sales and influencer campaigns for brands across automotive, BFSI, ecommerce, education, gaming and consumer tech. Those campaigns run on inventory that partners own. If you have an audience, a site, a list or an app, this is how you get paid campaigns from us.',
  types: [
    { key: 'influencer', title: 'Influencers and creators', p: 'Instagram, YouTube, X, LinkedIn and gaming streamers, from micro-influencers to large channels, in English, Hindi and regional languages. Paid per deliverable for launches, or per install, lead or sale when your link or code can be tracked.' },
    { key: 'publisher', title: 'Websites and content publishers', p: 'News, review, finance, auto, tech and niche content sites. Display, native placements, sponsored articles and performance offers on a cost per lead, cost per sale or cost per click basis.' },
    { key: 'email', title: 'Email and SMS list owners', p: 'Opt-in lists with a clear consent trail. Campaigns are paid per lead or per click with the brand\'s own landing page or API. We do not work with purchased or scraped lists.' },
    { key: 'coupon', title: 'Coupon and cashback sites', p: 'Coupon, deal and cashback platforms for ecommerce and app brands, usually on a cost per sale or cost per action model with approval rates reported per campaign.' },
    { key: 'app', title: 'App developers and SDK networks', p: 'In-app inventory, offerwalls and SDK traffic for app install and in-app event campaigns, with fraud checks on every source.' },
    { key: 'community', title: 'WhatsApp, Telegram and Discord communities', p: 'Owners of engaged community channels in finance, gaming, jobs, deals and education, for launches and performance offers that suit the group.' },
    { key: 'other', title: 'Other media', p: 'Podcasts, newsletters, YouTube channels without a face, live-stream agencies and anyone else who owns attention. Tell us what you have.' },
  ],
  standards: [
    'Traffic, leads and installs must come from real people who chose to engage. Incentivised, bot or bought traffic is rejected and not paid.',
    'Email and SMS partners must hold consent for every contact, in line with India\'s Digital Personal Data Protection Act and the rules of the market you send to.',
    'Paid creator posts must be disclosed, following the ASCI influencer advertising guidelines in India and local rules elsewhere.',
    'Payout model, rate and approval terms are agreed per campaign before it starts, in writing.',
  ],
  faqs: [
    { q: 'Who can join the DGTG partner network?', a: 'Influencers and creators, website publishers, opt-in email and SMS list owners, coupon and cashback sites, app developers and SDK networks, community owners and other media owners with a real audience.' },
    { q: 'How do partners get paid?', a: 'Depending on the campaign: per deliverable, per lead, per install, per sale, per click or per registration. The model and rate are agreed before each campaign starts.' },
    { q: 'Which markets do DGTG campaigns run in?', a: 'Mainly India, the UAE and Saudi Arabia, and Southeast Asia, with some campaigns in Europe and North America.' },
    { q: 'Is there a minimum audience size?', a: 'No fixed minimum. A small, engaged niche audience is often more useful to a brand than a large general one. Tell us your numbers and we will say which campaigns fit.' },
    { q: 'How long does it take to hear back?', a: 'We review every application and reply by email when there is a campaign that fits your audience.' },
  ],
};
